import React from "react";
import { Loader2 } from "lucide-react"; // Đảm bảo bạn đã cài `lucide-react`

const LoadingState = () => (
  <div className="py-32 flex flex-col items-center">
    <div className="relative">
      <Loader2 className="animate-spin text-indigo-600" size={48} />
      <div className="absolute inset-0 blur-xl bg-indigo-400/20 rounded-full animate-pulse"></div>
    </div>
    <p className="mt-6 text-slate-500 font-bold animate-pulse">
      Đang đồng bộ hóa dữ liệu thời gian thực...
    </p>
  </div>
);

export default LoadingState;
